<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5201_46568)">
      <circle cx="10" cy="10" r="9.5" stroke="#153D49" />
      <path
        d="M4.3275 9.0904C4.1155 8.51776 3.96198 7.93294 4.00828 7.31156C4.03752 6.92899 4.18129 6.60247 4.46152 6.33442C4.76611 6.04688 5.05365 5.74472 5.35338 5.45231C5.74326 5.0673 6.23305 5.06974 6.62293 5.45231C6.86417 5.68868 7.10297 5.92992 7.34178 6.17116C7.57327 6.40265 7.8072 6.63414 8.03869 6.86807C8.44563 7.27989 8.44807 7.75993 8.04113 8.16931C7.74872 8.46172 7.45874 8.75657 7.16146 9.04411C7.08348 9.11965 7.07617 9.183 7.11759 9.27804C7.31253 9.74589 7.5952 10.1626 7.91198 10.5525C8.55041 11.3371 9.27169 12.034 10.1319 12.5725C10.3171 12.6871 10.5193 12.7724 10.7118 12.8771C10.8117 12.9307 10.8775 12.9137 10.9579 12.8308C11.2479 12.5311 11.5452 12.2363 11.8425 11.9414C12.2324 11.5564 12.7197 11.554 13.1096 11.9414C13.5872 12.4142 14.0624 12.8893 14.5351 13.3669C14.9323 13.7666 14.9299 14.2563 14.5302 14.6584C14.2598 14.9313 13.9747 15.1896 13.7212 15.4747C13.3508 15.889 12.883 16.0254 12.3518 15.9962C11.5769 15.9548 10.8629 15.6965 10.1733 15.3626C8.64301 14.6194 7.3369 13.5887 6.24279 12.2874C5.43379 11.3225 4.76611 10.2747 4.3275 9.0904ZM15.9996 9.96277C15.9996 6.67557 13.324 4 10.0368 4V5.13553C12.6978 5.13553 14.8641 7.30182 14.8641 9.96277H15.9996ZM12.7343 9.96277H13.8699C13.8699 7.85009 12.1495 6.12973 10.0368 6.12973V7.26527C10.7581 7.26527 11.4355 7.54549 11.9448 8.05478C12.4541 8.56406 12.7343 9.24148 12.7343 9.96277Z"
        fill="#153D49"
      />
    </g>
    <defs>
      <clipPath id="clip0_5201_46568">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
